import * as React from 'react'

import Analytics from '../utils/genericAnalyticsClient'

const defaultAnalyticsClient = {
  trackEvent: (event: any, params: any) => {
    console.log('analytics::trackEvent', event, params)
  },
}

interface AnalyticsProps {
  analytics: {
    trackEvent: any
  }
  children: React.ReactNode
}

export const AnalyticsContext = React.createContext({})

export const AnalyticsConsumer = AnalyticsContext.Consumer

export const AnalyticsProvider = ({
  analytics = defaultAnalyticsClient,
  children,
}: AnalyticsProps) => (
  <AnalyticsContext.Provider
    value={{ analytics: { trackEvent: analytics.trackEvent } }}
  >
    {children}
  </AnalyticsContext.Provider>
)

export default {
  Client: Analytics,
  Consumer: AnalyticsConsumer,
  Provider: AnalyticsProvider,
}
